import "./app.css";
import { Component, xml, useState, onMounted } from "@odoo/owl";
import { Router, useService } from "./router";
import SearchForm from "./search_form";
import RecordList from "./recordlist";
import RecordDetail from "./record_detail";
import { ApiService } from "./services/api_service";
import { ROUTES, DEFAULT_PAGINATION } from "./constants";

/**
 * Főkomponens - Beadvány kereső alkalmazás
 */
export default class TirApp extends Component {
    static components = { Router, SearchForm, RecordList, RecordDetail };

    static template = xml`
        <div class="mab-search-form">
            <div class="container">
                <div class="row">
                    <Router>
                        <t t-set-slot="default" route="this.env.baseUrl || '/'">
                            <h1>Határozat kereső</h1>
                            <SearchForm 
                                onSearch.bind="handleSearch" 
                                search_params="state.searchParams"
                                metadata="state.metadata"
                            />
                        </t>
                        
                        <t t-set-slot="list" route="this.env.baseUrl + 'lista'">
                            <h1>Találatok</h1>
                            <RecordList
                                records="state.records"
                                metadata="state.metadata"
                                onSelectRecord.bind="handleSelectRecord"
                                currentPage="state.pagination.currentPage"
                                totalPages="state.pagination.totalPages"
                                onGoToPage.bind="goToPage"
                                onGoBack.bind="navigateToSearch"
                            />
                            <button class="btn btn-primary back-to-search" t-on-click="navigateToSearch">
                                Vissza
                            </button>
                        </t>
                        
                        <t t-set-slot="details" route="this.env.baseUrl + 'details'">
                            <RecordDetail 
                                recordId="state.selectedRecordId"
                                metadata="state.metadata" 
                                onBack.bind="navigateToList"
                            />
                        </t>
                    </Router>
                </div>
            </div>
        </div>
    `;

    setup() {
        super.setup();

        // API service inicializálása
        this.apiService = new ApiService(this.env.apiUrl);

        // Router service
        this.router = useState(useService("router"));

        // Állapot
        this.state = useState({
            records: [],
            selectedRecordId: null,
            searchParams: {},
            metadata: null,
            pagination: { ...DEFAULT_PAGINATION }
        });

        // Metadata betöltése indulásnál
        onMounted(async () => {
            await this.loadMetadata();
        });
    }

    // ===== Metadata betöltés =====

    async loadMetadata() {
        try {
            const metadata = await this.apiService.fetchMetadata();
            this.state.metadata = metadata;

            // Page size beállítása globális metadata értékből
            if (metadata.page_size) {
                this.state.pagination.pageSize = metadata.page_size;
            }
        } catch (error) {
            console.error("Error loading metadata:", error);
        }
    }

    // ===== Navigációs metódusok =====

    navigateToSearch() {
        this.router.navigate(ROUTES.SEARCH);
    }

    navigateToList() {
        this.router.navigate(ROUTES.LIST);
    }

    navigateToDetails() {
        this.router.navigate(ROUTES.DETAILS);
    }

    // ===== Event handler metódusok =====

    handleSelectRecord(recordId) {
        this.state.selectedRecordId = recordId;
        this.navigateToDetails();
    }

    async handleSearch(params) {
        this.state.searchParams = params;
        this.state.pagination.currentPage = 1;
        await this.fetchRecords();
        this.navigateToList();
    }

    async goToPage(pageNumber) {
        this.state.pagination.currentPage = pageNumber;
        await this.fetchRecords();
    }

    // ===== API hívások =====

    async fetchRecords() {
        try {
            const data = await this.apiService.fetchRecords(
                this.state.searchParams,
                this.state.pagination.currentPage,
                this.state.pagination.pageSize
            );

            this.state.records = data.records;
            if (data.pagination) {
                this.state.pagination = data.pagination;
            }
        } catch (error) {
            alert("Hiba történt a találatok lekérdezésekor!");
        }
    }

}

